//------------------------------------------------------------------------------
// BFA10104G 共架申込 通信設備 - 電柱一覧/検索フォーム
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import PoleSearchPanel from '@/pages/bfa/common/pole-search';

// 定数
const FORM_NAME = 'BFA10104G-POLE';

/**
 * 電柱検索フォーム
 */
function PoleSelectForm({
  values,
  change,
  onSearch,
  handleSubmit,
}) {
  //
  // 描画
  //
  return (
    <form noValidate autoComplete="off">
      <PoleSearchPanel
        values={values}
        change={change}
        onSearch={onSearch}
        handleSubmit={handleSubmit}
      />
    </form>
  );
}

// プロパティ
PoleSelectForm.propTypes = {

  // 検索処理
  onSearch: PropTypes.func.isRequired,

  // フォーム
  values: PropTypes.object,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

// ストア接続
PoleSelectForm = connect((state) => ({
  values: getFormValues(FORM_NAME)(state),
}))(PoleSelectForm);

// フォーム接続
PoleSelectForm = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
})(PoleSelectForm);

// エクスポート
export default PoleSelectForm;
